import clsx from "clsx";
import { FC } from "react";

import styles from "./LoadingEventsIndicator.module.css";

interface LoadingEventsIndicatorProps {
  /** Text shown beside the spinner, e.g. "Loading events". */
  label: string;
  /** Borderless, tighter layout for the narrow outline rail. */
  compact?: boolean;
  className?: string;
}

export const LoadingEventsIndicator: FC<LoadingEventsIndicatorProps> = ({
  label,
  compact = false,
  className,
}) => {
  return (
    <div
      role="status"
      aria-live="polite"
      className={clsx(styles.bar, compact && styles.compact, className)}
    >
      <span className={styles.spinner} aria-hidden="true" />
      <span className={styles.label}>
        {label}
        <span className={styles.ell} aria-hidden="true">
          <i>.</i>
          <i>.</i>
          <i>.</i>
        </span>
      </span>
    </div>
  );
};
